// extracted by mini-css-extract-plugin
export default {"cls1":"common-cls1___de7f5728abd1bf23121","cls2":"common-cls2___a4d0048b87e6d38477e common-cls1___de7f5728abd1bf23121"};